module.exports = __webpack_public_path__ + "img/favorite.db23be0c.svg";